import React from "react";
import { Card, ListGroup, Container, Row, Col, Image, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaFacebook, FaTiktok, FaYoutube, FaInstagram } from "react-icons/fa";
import Footer from "./footer";
import LatestUpdates from "./latestupdates";
import "./img.css";

const Citizenship = () => {
    return (
        <>
            <Container className="mt-4 px-3">
                <Row className="g-4">
                    {/* Left Section - Image and Title */}
                    <Col xs={12} md={8} className="text-center">
                        <Image src="./img/AAT.jpg" alt="Citizenship" fluid className="w-100" />
                        <h2 className="mt-3">Citizenship</h2>
                    </Col>

                    {/* Right Section - Latest Posts */}
                    <Col xs={12} md={4}>
                        <Card>
                            <Card.Header className="fw-bold">Latest Posts</Card.Header>
                            <ListGroup variant="flush">
                                <ListGroup.Item><Link to="/professional" className="text-decoration-none">Professional Year</Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/coursechange" className="text-decoration-none">Admissions And Course Change</Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/skilledID" className="text-decoration-none">Skilled Independent Visa (Subclass 189)</Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/workregionalvisa" className="text-decoration-none">Skilled Work Regional Visa (Subclass 491)</Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/nominatedvisa" className="text-decoration-none">Skilled Nominated Visa (Subclass 190)</Link></ListGroup.Item>
                                 <ListGroup.Item><a href="https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/skilled-regional-191"
                                                                    className="dropdown-item text-decoration-none"
                                                                    style={{ color: "#22327f" }}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                  >
                                                            Permanent Residence visa (Subclass 191)
                                                                  </a>
                                                                </ListGroup.Item>
                                {/* <ListGroup.Item><Link to="/regionalvisa" className="text-decoration-none">Skilled Regional Visa (Subclass 887)</Link></ListGroup.Item> */}
                                <ListGroup.Item><Link to="/tempactivity" className="text-decoration-none">Temporary Activity Visa (Subclass 408)</Link></ListGroup.Item>
                            </ListGroup>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <SecondSection />
            <LatestUpdates />
            <Footer />
        </>
    );
};

const SecondSection = () => {
    return (
        <Container className="mt-4 px-3">
            <Row className="g-4">
                <Col xs={12} md={8}>
                    <p>You can become a citizen of Australia in different ways. You must meet the selection criteria before you apply.
                        Conferral and descent are the most common ways to apply. Learn about being an Australian citizen.</p>

                    <h4 className="fw-bold text-decoration-underline">YOU CAN BECOME AN AUSTRALIAN CITIZEN IF:</h4>
                    <ul>
                        <li>You are a Permanent Resident of Australia.</li>
                        <li>Your parent was an Australian Citizen or permanent resident when you were born.</li>
                        <li>If your child was born and lived in Australia for 10 years*</li>
                    </ul>
                    <p>* Conditions applied</p>

                    <Container fluid className="p-4 bg-light border rounded">
                        <h5 className="fw-bold text-primary">WE CAN HELP YOU TO APPLY FOR YOUR CITIZENSHIP AND YOUR CHILD’S CITIZENSHIP!</h5>
                        <p className="text-dark">Contact us today, if you want to apply for Citizenship.</p>
                        
                        <motion.a
                            initial={{ x: "-100vw", opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
                            href="https://au.bajwaimmigration.com/book-appointment"
                            className="btn btn-danger btn-sm position-relative text-white text-decoration-none d-block mx-auto mt-3"
                        >
                            <i className="bi bi-chat-left-text me-1"></i>
                            Consult Now
                        </motion.a>
                    </Container>
                </Col>

                {/* Sidebar Section */}
                <Col xs={12} md={4}>
                    <Card className="p-3 text-center">
                        <Image src="./img/brand-logo.png" alt="Bajwa Immigration Logo" fluid className="mb-3 w-75 mx-auto" />
                        
                        <h6 className="fw-bold">Subscribe to our YouTube channel</h6>
                        <Button variant="danger" className="mb-3 w-100">
                            <a href="https://www.youtube.com/channel/UCB2YzDKqwiv4IH4A6zoKKWw" className="text-white text-decoration-none">SUBSCRIBE</a>
                        </Button>

                        <h6 className="fw-bold">Book Consultation</h6>
                        <Button variant="warning" className="w-100">BOOK CONSULTATION</Button>

                        <h6 className="fw-bold mt-3">Like Us on Facebook !!</h6>
                        <iframe
                            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FBajwaImmigration&tabs&width=340&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                            width="100%"
                            height="130"
                            style={{ border: "none", overflow: "hidden" }}
                            scrolling="no"
                            frameBorder="0"
                            allowFullScreen
                        ></iframe>

                        <h6 className="fw-bold mt-3">We are also on:</h6>
                        <div className="d-flex justify-content-center gap-3">
                            <FaInstagram size={30} color="#C13584" />
                            <FaTiktok size={30} color="#000" />
                            <FaYoutube size={30} color="crimson" />
                        </div>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Citizenship;